export default props => ({
    // Default theme
    buttonMargin: `${props.theme.horizontalLayoutSm} 0 0`,
    buttonWidth: `${props.theme.horizontalLayout2xl}`,
    errorHeader: `700 ${props.theme.type.type6} ${props.theme.font.default}`,
    errorHeaderMobile: `700 ${props.theme.type.type3} ${props.theme.font.default}`,
    errorIconColor: props.theme.error,
    errorIconDimension: `6.3rem`,
    errorIconDimensionMobile: `${props.theme.layoutSm}`,
    errorMessageMargin: `${props.theme.spacing2xl} 0 0`,
    headerMargin: `${props.theme.spacingMd} 0 0`,
    iconMargin: `0 0 ${props.theme.spacingMd} 0 0`,
    linkColor: props.theme.brand01,
    linkMargin: `0 0 0 ${props.theme.spacing2xs}`,
    messageFont: `400 ${props.theme.type.type0} ${props.theme.font.default}`,
    pageMargin: `${props.theme.spacing3xl} auto`,
    pagePadding: `${props.theme.horizontalSpacingMd}`,
    errorReasonColor: `${props.theme.ui03}`,

    // Override with custom theme
    ...props.theme?.ErrorPage
  });
